import { render, staticRenderFns } from "./DraftOfferDetailView.vue?vue&type=template&id=7f36d6c8&"
import script from "./DraftOfferDetailView.vue?vue&type=script&lang=js&"
export * from "./DraftOfferDetailView.vue?vue&type=script&lang=js&"
import style0 from "./DraftOfferDetailView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports